<template>
  <div>
    <img class="list_lmjp_image" v-if="pic" :src="pic" />
    <van-list
      v-model="loading"
      :finished="finished"
      loading-text="正在加载中..."
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      finished-text="我是有底线的哦 ~ "
      @load="onLoad"
      :immediate-check="false"
    >
      <!-- 上拉加载 -->
      <div class="comntmarginTop" style="display: flex; justify-content: flex-start; flex-wrap:wrap; align-items:stretch;" v-if="dataList.length>=1">
        <div v-for="(ele,index) in dataList" :key="index" @click="goHome(ele)" >
            <dl class="comntDl" v-if=" ele.houniaoAbroadStatus !==1">
              <dt>
                <van-image :src="ele.pic">
                  <template v-slot:error>加载失败</template>
                </van-image>
              </dt>
              <dd>
                <p class="ellpis">
                  <span v-if="ele.supplierCode=='ZY'" class="ZY">自营</span>
                  <span v-else-if="ele.houniaoAbroadStatus ===1" class="houniaoAbroadStatus">海外</span>
                  <span
                    v-if="ele.supplierCode=='ZY'"
                    :class="ele.supplierCode=='ZY'?'Name ':''"
                  >{{ele.name}}</span>
                  <span
                    v-else-if="ele.houniaoAbroadStatus ===1"
                    :class="ele.houniaoAbroadStatus==1?'Name ':''"
                  >{{ele.name}}</span>
                  <span v-else>{{ele.name}}</span>
                </p>
                <p>
                  <span class="EleName">￥{{ele.price}}</span>
                  <s class="EleOriginalPrice">￥{{ele.originalPrice}}</s>
                </p>
              </dd>
          </dl>
        </div>
      </div>
      <div v-else>
            <van-empty
              class="custom-image"
              :image="require('@/assets/boxsucces.png')"
              description="还没有相关商品呢"
            />
      </div>
    </van-list>
  </div>
</template>
<script>
import { List, PullRefresh, Image, Empty } from 'vant'
import { productList, activityList } from '../../request/api.js'
export default {
  name: 'searchList',
  components: {
    [Image.name]: Image,
    [List.name]: List,
    [Empty.name]: Empty,
    [PullRefresh.name]: PullRefresh
  },
  data () {
    return {
      pic: '',
      error: false,
      dataList: [], // 请求数据
      loading: false, // 上拉加载
      finished: false, // 上拉加载完毕
      isLoading: false, // 下拉刷新
      pageNum: 1 // 页码
    }
  },
  created () {
    console.log(this.$route.query)
    this.pic = this.$route.query.pic
    this.productListCode()
  },
  methods: {
    // 具体商品
    productListCode () {
      // 活动
      if (this.$route.query.keywords === '') {
        const params = {
          activityId: this.$route.query.id,
          pageSize: 12,
          pageNum: this.pageNum
        }
        console.log(params)
        activityList(params)
          .then(res => {
            console.log(res)
            this.dataList = res.data.list
          })
          .catch(res => {
            console.log(res)
          })
      } else {
        // 获取商品列表
        const params = {
          keyword: this.$route.query.keywords,
          pageSize: 12,
          pageNum: this.pageNum
        }
        console.log(params)
        productList(params)
          .then(res => {
            console.log(res)
            this.dataList = res.data.list
          })
          .catch(res => {
            console.log(res)
          })
      }
    },
    onLoad () {
      this.finished = false
      this.pageNum += 1
      if (this.$route.query.keywords === '') {
        const params = {
          activityId: this.$route.query.id,
          pageSize: 12,
          pageNum: this.pageNum
        }
        console.log(params)
        activityList(params)
          .then(res => {
            console.log(res)
            if (res.code === 200) {
              setTimeout(() => {
                this.dataList = this.dataList.concat(res.data.list)
                this.loading = false
                if (this.dataList.length >= res.data.total) {
                  this.finished = true
                  console.log('到底了')
                }
              }, 1000)
            } else {
              this.error = true
            }
          })
          .catch(res => {
            console.log(res)
          })
      } else {
        const params = {
          keyword: this.$route.query.keywords,
          pageSize: 12,
          pageNum: this.pageNum
        }
        console.log(params)
        productList(params)
          .then(res => {
            if (res.code === 200) {
              setTimeout(() => {
                this.dataList = this.dataList.concat(res.data.list)
                this.loading = false
                if (this.dataList.length >= res.data.total) {
                  this.finished = true
                  console.log('到底了')
                }
              }, 1000)
            } else {
              this.error = true
            }
          })
          .catch(res => {
            console.log(res)
          })
      }
    },
    onRefresh () {
      setTimeout(() => {
        console.log('下拉刷新')
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.isLoading = false
        this.onLoad()
      }, 1000)
    },
    goHome (ele) {
      this.$router.push({ path: '/CommodityDetails', query: { id: ele.id, skuId: ele.defaultSkuId } })

      // this.$router.push(`/CommodityDetails/${ele.id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.list_lmjp_image {
  max-width: 100%;
}
.van-list {
  padding-top: 20px;
}
.EleName {
  color: #333333;
  font-size: 32px;
  font-weight: bold;
  padding-right: 15px;
}
.EleOriginalPrice {
  color: #999999;
  font-size: 28px;
}
.comntmarginTop {
  padding-left: 30px;
}
.comntmarginTop dl:nth-child(odd) {
  //所有奇数
  margin-right: 18px;
}
.comntDl {
  width: 336px;
  border-radius: 4px 4px 0px 0px;
  dt {
    width: 100%;
    height: 336px;
    .van-image {
      width: 100%;
      height: 100%;
    }
  }
  dd {
    height: 120px;
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 20px;
    p{
      margin-bottom: 7px;
    }
  }
}
.ZY {
  color: white;
  padding: 2px 12px;
  font-size: 24px;
  border-radius: 5px;
  background-color: #E33F36;
}
//多行文本溢出隐藏
.ellpis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.houniaoAbroadStatus {
  color: #E33F36;
  padding: 1px 12px;
  font-size: 24px;
  border-radius: 5px;
  border: 1px solid #E33F36; /*no*/
}
/deep/.van-tabs__line {
  background-color: #E33F36;
  width: 60px;
}
/deep/ .van-empty{
  position: relative;
}
    //占位符
    /deep/ .van-empty__image{
      width: 395.1px;
      height: 346.1px;
      margin-bottom: 32px;
      margin-top: 300px;
    }
    /deep/ .van-empty__description{
      font-size: 28px;
      color: #999999;
      position: absolute;
      bottom: 120px;
    }
</style>
